import type { ChartType, ChartData, DefaultDataPoint, ChartDataset } from 'chart.js';

export function setDatasets<
    TType extends ChartType = ChartType,
    TData = DefaultDataPoint<TType>,
    TLabel = unknown
>(
    currentData: ChartData<TType, TData, TLabel>,
    nextDatasets: ChartDataset<TType, TData>[],
    datasetIdKey: string
) {
    const addedDatasets: ChartDataset<TType, TData>[] = [];
    currentData.datasets = nextDatasets.map(
        (nextDataset: Record<string, unknown>) => {
            const currentDataset = currentData.datasets.find(
                (dataset: Record<string, unknown>) =>
                    dataset[datasetIdKey] === nextDataset[datasetIdKey]
            );
            if (
                !currentDataset ||
                !nextDataset['data'] ||
                addedDatasets.includes(currentDataset)
            ) {
                return { ...nextDataset } as ChartDataset<TType, TData>;
            }
            addedDatasets.push(currentDataset);
            Object.assign(currentDataset, nextDataset);
            return currentDataset;
        }
    );
}
